/** In dev (localhost), use CRA proxy paths in setupProxy.js to avoid Cloud Functions CORS on browser. */
export const BaseUrl = (function () {
  const env = process.env.REACT_APP_CUSTOM_ENV;
  if (typeof window !== "undefined" && window.location?.hostname === "localhost") {
    if (env === "prod") return `${window.location.origin}/cloudfunctions-prod/`;
    if (env === "stage") return `${window.location.origin}/cloudfunctions-stage/`;
    return `${window.location.origin}/cloudfunctions-dev/`;
  }
  if (env === "prod") return "https://us-central1-csmg-a0cd2.cloudfunctions.net/";
  if (env === "stage") return "https://us-central1-proteams-stage.cloudfunctions.net/";
  return "https://us-central1-csmg-dev-dc546.cloudfunctions.net/";
}());

const host = window.location.hostname;
const CLIENT_DOMAINS = ["appdev.proteams.io"];
const SUPERUSER_DOMAINS = ["admin1989.proteams.io", "adminstage1989.proteams.io"];

// console.log("BaseUrl1>>", BaseUrl1);
// export const BaseUrl = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://us-central1-csmg-a0cd2.cloudfunctions.net/' : 'https://us-central1-csmg-dev-dc546.cloudfunctions.net/';

export const DOMAINURL = (() => {
  if (process.env.REACT_APP_CUSTOM_ENV === "prod") {
    return host === "app.proteams.io" ? "app.proteams.io" : "admin1989.proteams.io";
  }
  else if (process.env.REACT_APP_CUSTOM_ENV === "stage") {
    return host === "stage.proteams.io" ? "stage.proteams.io" : "adminstage1989.proteams.io";
  }
  else return host === "appdev.proteams.io" ? "appdev.proteams.io" : "dev.proteams.io";
})();

// export const DOMAINURL = (function() {
//   if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'proteams.io';
//   else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stage.proteams.io';
//   else return 'dev.proteams.io';
// }());
// export const DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'proteams.io' : 'dev.proteams.io';

export const APP_DOMAINURL = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'https://appview.proteams.io/auth/loginweb/';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'https://appviewstage.proteams.io/auth/loginweb/';
  else return 'https://appviewdev.proteams.io/auth/loginweb/';
}());

// export const APP_DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://appview.proteams.io/auth/loginweb/' : 'https://appviewdev.proteams.io/auth/loginweb/';

// export const APP_DOMAINURL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'https://appview.proteams.io/auth/loginweb/' : 'http://localhost:5173/auth/loginweb/';
// export const APP_DOMAINURL = 'http://localhost:5173/auth/loginweb/';

export const ISSUE_DOMAIN = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'https://issues.proteams.io/';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'https://issuesstage.proteams.io/';
  else return 'https://issuesdev.proteams.io/';  
}());
// export const ISSUE_DOMAIN = process.env.REACT_APP_CUSTOM_ENV === "prod" ? 'http://issues.proteams.io/' : 'http://issuesdev.proteams.io/';

export const EMP_DOMAIN = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'emp.proteams.io';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stageemp.proteams.io';
  else return 'devemp.proteams.io';  
}());

export const DOMAINURL_SUPPIESEMAIL = (function() {
  if(process.env.REACT_APP_CUSTOM_ENV === "prod") return 'emp.proteams.io';
  else if(process.env.REACT_APP_CUSTOM_ENV === "stage") return 'stageemp.proteams.io';
  else return 'devemp.proteams.io';  
}());

// export const DOMAINURL_SUPPIESEMAIL = 'devemp.proteams.io';
// STRIPE_SECRETE and STRIPE_ENDPOINT_SECRETE removed - use Cloud Functions stripeProxy endpoints instead.
// STRIPE_PUBLISHABLE_KEY and STRIPE_CLIENT_ID moved to Cloud Functions - fetch via getAppConfig() or getStripeConfigs()



// export const SENDER_EMAIL = "proteams.io@procleanings.com";
export const DOMAIN_TYPES = {
  SUPERUSER_ONLY: "SUPERUSER_ONLY",
  CLIENT_ONLY: "CLIENT_ONLY",
  ALL: "ALL",
};

export const DOMAIN_TYPE = (() => {
  if (SUPERUSER_DOMAINS.includes(host)) {
    return DOMAIN_TYPES.SUPERUSER_ONLY;
  }

  if (CLIENT_DOMAINS.includes(host)) {
    return DOMAIN_TYPES.CLIENT_ONLY;
  }

  return DOMAIN_TYPES.ALL;
})();


export const APP_STORE_ID = "apps.apple.com/us/app/proteams-io/id1638524286";

export const PLAY_STORE_ID = "play.google.com/store/apps/details?hl=en_US&id=co.csm.procleaning";

export const ROLES = {
  CLIENT: 'Client',
  EMPLOYEE: 'Employee',
  ADMIN: 'admin',
  SUPPORT: 'support',
  SUPERUSER: 'superUser',
  COMPANYUSER: 'companyUser'
};

export const EMP_ROLES = {
  CLIENT_TEAM: 'Client Team',
  ADMIN: 'Admin',
  /** Legacy CMS employee role; kept for routing + existing user records — not offered in role pickers. */
  GUEST: 'Guest',
  SUPPORT: 'Support'
};
export const COLLECTIONS = {
  USERS: 'users',
  EMPLOYEE: 'employees',
  GROUPS: 'groups',
  CLIENT: 'clientsNew',
  SHIFTS: 'shifts',
  TIMESHEETS: 'timesheets',
  STANDARDTAKS: 'standardTasks',
  SUPPLIES_CLEANINGS: 'supplies_cleanings',
  SUPPLIES_ORDER: 'supply_order',
  SUPPLIES_CATEGORY: 'supplies_category',
  SUPPLIES_ORDER_NOTES: 'supply_order_notes',
  ISSUES: 'issues',
  ADMIN_STAT_DATA_COUNT: 'stat_data',
  NOTIFICATIONS: 'notifications',
  ALERT: 'alerts',
  CHAT_CHANNELS: 'chat_channels',
  CHAT_MESSAGES: 'chat_messages',
  USER_ACTIVITY_LOG: 'user_activity_log',
  ISSUE_NOTIFICATIONS:'issue_notifications',
  APPOINMENTS:'appoinments',
  NOTIFICATION_SETTINGS: 'notification_settings',
  ISSUE_SETTINGS: 'issue_settings',
  APPOINTMENT_SETTINGS: 'appointment_settings',
  CLIENT_SETTINGS: 'client_settings',
  SUPPLIES_SETTINGS: 'supplie_settings',
  SUPPLIES_COMPANY_CATEGORY: 'supplies_company_category',
  SUPPLIES_INDUSTRY: 'supplies_industry',
  STRIPE_EVENT: 'strip_events',
  STRIPE_PRODUCTS: 'strip_products',
  STRIPE_INVOICE: 'strip_invoice',
  STRIPE_SUBSCRIPTION: 'strip_subscription',
  STRIPE_CARDS: "strip_cards",
  STRIPE_CHARGES: "strip_charge",
  SUPPORT: "support",
  HISTORY: 'history',
  SYSTEM_SETTINGS: 'system_settings',
  EMAIL_TRACKING: 'email_tracking',
  PAYMENT_VERIFICATION: 'payment_verification',
  STRIPE_SUBSCRIPTION_SCHEDULES: 'stripe_subscription_schedules',
  INVOICES: 'invoices',
  INVOICE_SETTINGS: 'invoice_settings',
  USER_ACTION_LOG: 'userActionLog',
};
